import Layout from "../../../components/layout/layout.js";

import CalendarForm from "../../../components/form/calendar.form";

function CalendarPage({ component, ...rest }) {
  return <Layout Component={CalendarForm} {...rest} />;
}

export default CalendarPage;
